<div class="right-panel h-100">
  <div class="right-side h-100">
    <as-split direction="horizontal">
      <as-split-area [size]="detailsViewOpen ? 20 : 100">
        <div class="pod-list">
          <div class="actionBar mt-0">
            <div class="flex-grow-1 d-flex gap-2">
              <input
                class="search p-2"
                type="text"
                placeholder="Search by name"
                [(ngModel)]="podSearchText"
                (ngModelChange)="applyFilter()"
              />
            </div>
            <button
              type="button"
              class="actionBtn"
              (click)="refreshComponent()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Refresh Jobs"
            >
              <span class="bi bi-arrow-clockwise"></span>
              <span class="button-animation">&nbsp;Refresh</span>
            </button>

            <button
              type="button"
              class="actionBtn"
              [ngbPopover]="filterContent"
              #filterPopover="ngbPopover"
              [autoClose]="'outside'"
              popoverClass="filter-popover"
              container="body"
              placement="top auto"
              (mouseenter)="tooltipInstance.open()"
              (mouseleave)="tooltipInstance.close()"
              [ngbTooltip]="'Show/Hide Filters'"
              #tooltipInstance="ngbTooltip"
            >
              <span class="bi bi-funnel"></span>
              <span
                class="position-absolute top-0 start-100 badge rounded-pill"
                *ngIf="getActiveFiltersCount() > 0"
              >
                {{ getActiveFiltersCount() }}
                <span class="visually-hidden">unread messages</span>
              </span>
            </button>
            <button
              class="actionBtn"
              (click)="editColoum()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Add/Remove columns from table"
            >
              <span><i class="bi bi-sliders"></i></span>
            </button>
            <button
              type="button"
              class="actionBtn"
              (click)="openCreatePodDialog()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Request a Pod"
            >
              <span class="bi bi-terminal-plus"></span>
              <span class="button-animation">&nbsp;Request a Pod</span>
            </button>
            <button
              type="button"
              class="actionBtn"
              (click)="openCodeServer()"
              placement="top auto"
              container="body"
              triggers="hover"
              ngbTooltip="Open Code Server"
            >
              <span class="bi bi-file-earmark-code"></span>
            </button>

            <a
              *ngIf="JupyterHubUrl"
              [href]="JupyterHubUrl"
              target="_blank"
              rel="noopener"
              class="mx-2"
              ngbTooltip="Open JupyterHub"
              placement="top auto"
              container="body"
              triggers="hover"
            >
              <img
                src="assets/images/syncious/Jupyter_logo.svg"
                alt="JupyterHub Logo"
                class="p-0 zoom-hover"
                style="height: 30px"
              />
            </a>
          </div>

          <div
            class="listTable flex-grow-1"
            style="white-space: nowrap"
            *ngIf="available"
          >
            <div class="flex-grow-1">
              <table
                class="table table-hover"
                cellspacing="0"
                style="border-collapse: collapse"
              >
                <thead style="text-align: left">
                  <tr class="table-list-head">
                    <th scope="col" resizable>#</th>
                    <th scope="col" resizable>Pod Name
                      <span
                        style="margin-left: 2px;"
                        (click)="sortByPodName(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <th scope="col" resizable>Pod IP</th>
                    <th scope="col" resizable>Node
                      <span
                        style="margin-left: 2px;"
                        (click)="sortByPodNode(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <th scope="col" resizable>User
                      <span
                        style="margin-left: 2px;"
                        (click)="sortByPodUser(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <th scope="col" resizable>Job
                      <span
                        style="margin-left: 2px;"
                        (click)="sortByPodJob(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <th scope="col" resizable>Namespace
                      <span
                        style="margin-left: 2px;"
                        (click)="sortByPodNamespace(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <!--<th scope="col" resizable>Ready</th>-->
                    <th scope="col" resizable>
                      Phase
                      <span
                        style="margin-left: 2px;"
                        (click)="sortPhase(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <th
                      *ngIf="nodeListColumnToShow?.includes('Create Time')"
                      scope="col"
                      resizable
                    >
                      Create Time
                      <span
                        style="margin-left: 2px;"
                        (click)="sortByCreateTime(true)"
                        title="Sort Ascending/Descending"
                        class="bi bi-arrow-down-up"
                      ></span>
                    </th>
                    <th
                      *ngIf="nodeListColumnToShow?.includes('Restart Count')"
                      scope="col"
                      resizable
                    >
                      Restart Count
                    </th>
                    <th
                      *ngIf="nodeListColumnToShow?.includes('CPU')"
                      scope="col"
                      resizable
                    >
                      CPU
                    </th>
                    <th
                      *ngIf="nodeListColumnToShow?.includes('Memory')"
                      scope="col"
                      resizable
                    >
                      Memory
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="table-list-row"
                    *ngFor="
                      let pod of applyFilter()
                        | paginate : { itemsPerPage: 15, currentPage: p };
                      let i = index
                    "
                  >
                    <td>{{ 15 * (p - 1) + (i + 1) }}</td>
                    <td class="impListName" (click)="togglePodView(pod)">
                      {{ pod.podName }}
                    </td>
                    <td>{{ pod.podIP }}</td>
                    <td>{{ pod.node }}</td>
                    <td>{{ pod.userName || "NA" }}</td>
                    <td>{{ pod.podOwnerName || "NA" }}</td>
                    <td>{{ pod.namespace }}</td>
                    <!--<td>{{ pod.ready }}</td>-->
                    <td>{{ pod.status }}</td>
                    <td *ngIf="nodeListColumnToShow?.includes('Create Time')">
                      {{ pod.age | date : "short" : "+0530" : "en-IN" }}
                    </td>
                    <td *ngIf="nodeListColumnToShow?.includes('Restart Count')">
                      {{ pod.restartCount }}
                    </td>
                    <td *ngIf="nodeListColumnToShow?.includes('CPU')">
                      {{ pod.cpuInCore }}
                    </td>
                    <td *ngIf="nodeListColumnToShow?.includes('Memory')">
                      {{ pod.memoryInMB }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex mt-1" *ngIf="available === true">
              <pagination-controls
                *ngIf="available === true"
                class="my-pagination"
                (pageChange)="p = $event"
              ></pagination-controls>
            </div>
          </div>
          <p id="emptyError" *ngIf="available === false">
            No Pods are available for selected deployment
          </p>
        </div>
      </as-split-area>

      <as-split-area [size]="detailsViewOpen ? 80 : 0" *ngIf="detailsViewOpen">
        <app-pod-advance-view
          (actionPerform)="performAction($event)"
          (hideDetails)="hidePodDetails()"
        ></app-pod-advance-view>
      </as-split-area>
    </as-split>
  </div>
</div>

<ng-template #filterContent>
  <div class="filter-container">
    <div class="filter-section">
      <label>Nodes</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterNodes"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Nodes</ng-option>
          <ng-option *ngFor="let n of nodeList" [value]="n">{{ n }}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="filter-section">
      <label>Namespace</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterNamespace"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Namespace</ng-option>
          <ng-option *ngFor="let n of namespacesList" [value]="n">{{
            n
          }}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="filter-section">
      <label>Job</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterJob"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Jobs</ng-option>
          <ng-option value="NA">NA</ng-option>
          <ng-option *ngFor="let job of jobList" [value]="job">{{
            job
          }}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="filter-section">
      <label>Phase</label>
      <div class="field-container">
        <ng-select
          [(ngModel)]="filterPhase"
          (ngModelChange)="applyFilter()"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-option value="All">All Phases</ng-option>
          <ng-option *ngFor="let phase of phaseList" [value]="phase">{{
            phase
          }}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <button type="button" class="reset-button" (click)="resetFilter()">
        <svg
          class="reset-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
          />
        </svg>
        Reset Filters
      </button>
    </div>
  </div>
</ng-template>

<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="create-code-server"
>
  <p>Please Wait...</p>
</ngx-spinner>
